import React from 'react';
import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap';
import FadeIn from 'react-fade-in/lib/FadeIn';
import { isEventPlaying } from '../../Helpers/DateHelper';
import BannerCountdown from '../BannerCountdown';
import SchedulePopover from '../SchedulePopover';
import { formattedSportFlights } from '../../../../utils/dateFnsUtils';

function BannerHeroCaption({
  content,
  translationTexts,
  redirectHandler,
  onClickPlayerButton,
  showProps = {
    availableIn: false,
    maxRating: false,
  },
  selectedContentHandler,
  showScheduleButton = true
}) {
  const {
    play_in,
    play_now,
    available_in,
    go_to_site,
    go_to_path,
    schedule,
    live_on,
    at,
  } = translationTexts ?? {};

  const checkRedirect = (entitlementTypes) => {
    return entitlementTypes.some((e) => e === 'media');
  };

  const isPlayNow =
    content?.relatedContent?.live && content?.relatedContent?.flights?.length
      ? isEventPlaying(content.relatedContent?.flights?.[0]?.flights?.[0])
      : true;

  const [dateEvent, timeEvent] = formattedSportFlights(
    content?.relatedContent?.flights?.[0]?.flights
  );

  return (
    <div className='bannerHeroCarouselCaption carousel-caption'>
      <div className='bannerHeroInfo'>
        <FadeIn>
          <div className='bannerHeroData'>
            {showProps.maxRating &&
              content.relatedContent &&
              content.relatedContent.ratings && (
                <div className='ratingBadge'>
                  {content.relatedContent.ratings.map((rating) => {
                    return rating;
                  })}
                </div>
              )}
            {showProps.availableIn &&
              content.relatedContent &&
              content.relatedContent.networks && (
                <div className='networkBadge'>{`${available_in}: ${content.relatedContent.networks.map(
                  (network) => {
                    return network.name;
                  }
                )}`}</div>
              )}
          </div>
          <div className='bannerHeroTitle'>
            {content.title && <h2>{content.title}</h2>}
          </div>
          {(content.externalUrl ||
            content.sectionUrl ||
            (content.relatedContent &&
              content.relatedContent.entitlementTypes &&
              checkRedirect(content.relatedContent.entitlementTypes)) ||
            content?.relatedContent?.networks) && (
            <div className='bannerHeroActions'>
              {content.externalUrl ? (
                <Button
                  className='play'
                  onClick={() =>
                    redirectHandler(
                      content.externalUrl,
                      'externalUrl',
                      content.externalUrlTarget
                    )
                  }
                >
                  <span>{go_to_site}</span>
                </Button>
              ) : (
                content.sectionUrl && (
                  <Button
                    className='play'
                    onClick={() =>
                      redirectHandler(content.sectionUrl, 'sectionUrl')
                    }
                  >
                    <span>{`${go_to_path} ${
                      content.sectionName || 'la sección'
                    }`}</span>
                  </Button>
                )
              )}

              {content.relatedContent &&
                !content.relatedContent?.live &&
                (content.relatedContent.entitlementTypes &&
                checkRedirect(content.relatedContent.entitlementTypes) ? (
                  <Button
                    className='play'
                    onClick={() =>
                      selectedContentHandler(content.relatedContent)
                    }
                  >
                    <i className='bi bi-play-fill'></i>
                    <span>{play_now}</span>
                  </Button>
                ) : (
                  content.relatedContent?.networks && (
                    <Button
                      className='play'
                      onClick={() =>
                        selectedContentHandler(content.relatedContent)
                      }
                    >
                      {!isPlayNow && (
                        <span>{`${play_in}: ${content.relatedContent.networks.map(
                          (network) => network.name
                        )}`}</span>
                      )}
                      {isPlayNow && (
                        <>
                          <i className='bi bi-play-fill'></i>
                          <span>{play_now}</span>
                        </>
                      )}
                    </Button>
                  )
                ))}

              {content.relatedContent && content.relatedContent?.live && (
                <>
                  {!isPlayNow && (
                    <div className='countdown'>
                      <p className='availableBadge'>
                        {live_on} {dateEvent} {at} {timeEvent}
                      </p>
                      {showScheduleButton ? <SchedulePopover
                        content={content.relatedContent}
                        schedule={schedule}
                      /> : (
                        <Button
                          className='play'
                          onClick={() =>
                            selectedContentHandler(content.relatedContent)
                          }
                        >
                          <i className='bi bi-play-fill'></i>
                          <span>{play_now}</span>
                        </Button>
                      )}
                    </div>
                  )}

                  {isPlayNow && (
                    <Button
                      className='play'
                      onClick={() =>
                        selectedContentHandler(content.relatedContent)
                      }
                    >
                      <i className='bi bi-play-fill'></i>
                      <span>{play_now}</span>
                    </Button>
                  )}
                </>
              )}
            </div>
          )}
        </FadeIn>
      </div>
    </div>
  );
}

export default BannerHeroCaption;
